import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "KSalesmenTable",

	mixins: [ Crudable ],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no salesmen to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching salesmen found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "user.name"
		}
	},

	data: () => ( {
		crud: "salesmen"
	} ),

	computed: {
		canDelete() {
			return this.$can( "delete_salesmen" );
		},

		defaultHeaders() {
			return [
				{
					text: "Name",
					value: "user.name"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteSalesman( salesman ) {
			const deleteIndex = this.items.findIndex( item => salesman.id === item.id );

			return salesman.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "salesman",
								params: { idSalesman: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete salesman" )}
								onConfirm={() => this.deleteSalesman( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Salesman"
							>
								Are you sure you want to delete the salesman <strong>{item.user.name}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
